import { render, staticRenderFns } from "./FinancialGroupsComparison.vue?vue&type=template&id=3fd6de0a&scoped=true&"
import script from "./FinancialGroupsComparison.vue?vue&type=script&lang=js&"
export * from "./FinancialGroupsComparison.vue?vue&type=script&lang=js&"
import style0 from "./FinancialGroupsComparison.vue?vue&type=style&index=0&id=3fd6de0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd6de0a",
  null
  
)

export default component.exports